"use client";

import Link from "next/link";
import { FormEvent, useState } from "react";
import { Button, Input, Panel } from "@/components/ui";
import { useToast } from "@/components/toast";
import { api } from "@/lib/api";
import { useI18n } from "@/components/shell";

export default function ForgotPage() {
  const { locale, tt } = useI18n();
  const { toastError, toastOk } = useToast();
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  async function onRequest(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api<{ email: string; dev_link?: string | null }>("/v1/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email, locale }),
      });
      setEmail(res.email);
      if (res.dev_link) toastOk(tt("devResetLink", { link: res.dev_link }), 15000);
      setSent(true);
    } catch (err) {
      toastError(err instanceof Error ? err.message : tt("loginFailed"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-md">
      <Panel className="rounded-lg border-slate-700 bg-slate-800 p-8 shadow-2xl">
        {sent ? (
          <>
            <h1 className="text-2xl font-bold text-white">{tt("forgotCheckTitle")}</h1>
            <p className="mt-2 text-sm text-slate-400">{tt("forgotCheckBody", { email })}</p>
            <p className="mt-4 text-sm text-mute">{tt("forgotSent")}</p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-white">{tt("forgotTitle")}</h1>
            <p className="mt-2 text-sm text-slate-400">{tt("forgotHint")}</p>
            <form onSubmit={onRequest} className="mt-6 space-y-4">
              <Input
                label={tt("email")}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Button className="w-full" disabled={busy}>
                {tt("sendResetLink")}
              </Button>
            </form>
          </>
        )}
        <p className="mt-4 text-center text-xs text-slate-500">
          <Link href="/login" className="link-accent">
            {tt("backToLogin")}
          </Link>
        </p>
      </Panel>
    </div>
  );
}
